var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportInstagramFeedComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9401 4.0039C6.60677 0.670571 3.6901 5.39279 3.27344 8.17057V11.0874L4.10677 13.1707L3.57094 16.4288L5.77344 15.6707H7.02344L12.0234 16.0874L16.6068 13.1707L17.4401 11.0874L17.8568 8.17057L14.9401 4.0039Z",
    fill: "#2AAE81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3574 16.1908C14.4996 16.1908 17.8574 13.206 17.8574 9.52409C17.8574 5.84219 14.4996 2.85742 10.3574 2.85742C6.21529 2.85742 2.85742 5.84219 2.85742 9.52409C2.85742 10.836 3.28373 12.0594 4.01991 13.0908L3.79396 16.1908L6.81131 15.4C7.86718 15.9045 9.0747 16.1908 10.3574 16.1908Z",
    stroke: "#2AAE81",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 10H6.67435M9.99935 10H10.0077M13.3327 10H13.341",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportInstagramFeedComment);
export default __webpack_public_path__ + "static/media/report-instagram-feed-comment.ca60e8f1ffe8f08a3cb710db6b22e0d8.svg";
export { ForwardRef as ReactComponent };